import { StyleRules } from '@material-ui/core/styles';
import { TabsClassKey } from '@material-ui/core/Tabs';

export const MuiTabs: Partial<StyleRules<TabsClassKey>> = {
  flexContainer: {
    '& > :not(:first-of-type)': {
      marginLeft: 24,
    },
  },
  indicator: {
    '$vertical &': {
      left: 0,
      right: 'initial',
    },
  },
};
